import type { SegmentMst } from '@libs/domain';

export class SegmentGrid implements Pick<SegmentMst['schema'], 'key' | 'segmentMstCode' | 'segmentMstName'> {
  /**
   *
   * セグメント情報で使うmodel
   *
   * @param key セグメントキー
   */
  private constructor(
    readonly key: number,
    readonly segmentMstCode: string,
    readonly segmentMstName: string,
  ) {}

  static fromRaw(raw: SegmentGridRaw) {
    return new SegmentGrid(raw.key, raw.segmentMstCode, raw.segmentMstName);
  }
}

export interface SegmentGridRaw {
  key: number;
  segmentMstCode: string;
  segmentMstName: string;
}
